module.exports = __webpack_public_path__ + "static/insurance-4afbeb5cbe675a8064cd1b105da3d248.png";